import { render } from "./About.component.html?vue&type=template&id=78c6ad94&ts=true&external"
import script from "./About.component.ts?vue&type=script&lang=ts&external"
export * from "./About.component.ts?vue&type=script&lang=ts&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__